import { InsuredPeopleDto, OnboardingPeriodReportDto } from '@zorro/clients';
import { formatDateEnLocaleMonthDay } from '@zorro/shared/formatters';

export const formatElectionWindowSubtitle = (
  onboardingPeriod: OnboardingPeriodReportDto
) => {
  return `Election window ${formatDateEnLocaleMonthDay(onboardingPeriod.onboardingFrom)} - ${formatDateEnLocaleMonthDay(onboardingPeriod.onboardingUntil)}`;
};

export const getInsuredNames = ({
  employee,
  spouse,
  dependents,
}: InsuredPeopleDto): string[] => {
  const whoIsEnrolled: string[] = [];
  whoIsEnrolled.push(employee.firstName);
  if (spouse) {
    whoIsEnrolled.push(spouse.firstName);
  }
  dependents.forEach((dependent) => whoIsEnrolled.push(dependent.firstName));

  return whoIsEnrolled;
};
